import { pictoOldCabinetData } from './picto_extract';
import { colorParser, dataParser, loadOldCabinet } from './converter';
import { colorsDataXML } from '../../tests/fixtures/old/colors.data';
import { Cabinet } from '../../entities/Cabinet';

function* oldCabinetGenerator() {
  const data = new Set(pictoOldCabinetData);
  for (const element of data) {
    yield element;
  }
}
const genOldCabinet = oldCabinetGenerator();

export function getNextOldCabinetId(): string {
  const iter = genOldCabinet.next();
  if (iter.done) {
    return '88780056';
  } else {
    return iter.value?.toString();
  }
}

export async function convertAll() {
  const colorsData = colorParser(colorsDataXML);

  const allData = new Set(pictoOldCabinetData);

  for (const id of allData) {
    const dataXML = await loadOldCabinet(id.toString());
    if (dataXML) {
      try {
        const cabinet = dataParser(dataXML, colorsData);
      } catch (error) {
        console.error(`Error with cabinet ${id} ${error}`);
      }
    }
  }
}

export async function convertCabinet(id: string): Promise<Cabinet> {
  const colorsData = colorParser(colorsDataXML);

  const dataXML = await loadOldCabinet(id.toString());
  return new Promise((resolve, reject) => {
    if (dataXML) {
      try {
        const cabinet = dataParser(dataXML, colorsData);
        resolve(cabinet);
      } catch (error) {
        reject(error);
      }
    } else {
      reject(`Could'nt load the XML from old Kewapp`);
    }
  });
}
